import { css } from "@emotion/css";
import { borderRadius, borderWidth, space, themeTokens, text } from "@octopusdeploy/design-system-tokens";
import type { ArgoCDApplicationSourceSyncDetailResource } from "@octopusdeploy/octopus-server-client";
import { commonStyles } from "~/areas/projects/components/Observability/ObjectDrawer/Tabs/commonStyles";
import { Revision } from "~/areas/projects/components/Observability/ObjectDrawer/Tabs/components/Revision";
const styles = {
    container: css({
        padding: space[16],
        borderTop: `${borderWidth[1]} solid ${themeTokens.color.border.primary}`,
        display: "flex",
        flexDirection: "column",
        gap: space[16],
    }),
    header: css({
        margin: 0,
        font: text.body.bold.large,
        color: themeTokens.color.text.primary,
    }),
    card: css({
        paddingLeft: space[16],
        paddingRight: space[16],
        border: `${borderWidth[1]} solid ${themeTokens.color.border.primary}`,
        borderRadius: borderRadius["large"],
        boxShadow: themeTokens.shadow.extraSmall,
    }),
};
type ArgoCDApplicationSyncDetailsProps = {
    syncDetails: ArgoCDApplicationSourceSyncDetailResource[];
};
export const ArgoCDApplicationSyncDetails = (props: ArgoCDApplicationSyncDetailsProps) => {
    const { syncDetails } = props;
    if (syncDetails.length === 0) {
        return null;
    }
    const nameDetails = (name: string | null) => {
        if (!name) {
            return;
        }
        return (<>
                <dt>Name</dt>
                <dd>{name}</dd>
            </>);
    };
    const ociDetails = (detail: ArgoCDApplicationSourceSyncDetailResource) => (<>
            <dt>OCI Image</dt>
            <dd>{detail.RepositoryUrl}</dd>
            {nameDetails(detail.Name)}
            <dt>Revision</dt>
            <dd>{detail.Revision}</dd>
        </>);
    const helmDetails = (detail: ArgoCDApplicationSourceSyncDetailResource) => (<>
            <dt>Chart source</dt>
            <dd>{detail.RepositoryUrl}</dd>
            {nameDetails(detail.Name)}
            <dt>Revision</dt>
            <dd>{detail.Revision}</dd>
        </>);
    const defaultDetails = (detail: ArgoCDApplicationSourceSyncDetailResource) => (<>
            <dt>Source</dt>
            <dd>{detail.RepositoryUrl}</dd>
            {nameDetails(detail.Name)}
            <dt>Commit</dt>
            <dd>
                <Revision repositoryUrl={detail.RepositoryUrl} revision={detail.Revision}/>
            </dd>
        </>);
    const getDetails = (detail: ArgoCDApplicationSourceSyncDetailResource) => {
        const isOci = detail.RepositoryUrl.startsWith("oci://");
        if (isOci) {
            return ociDetails(detail);
        }
        if (detail.IsHelmSource) {
            return helmDetails(detail);
        }
        return defaultDetails(detail);
    };
    return (<div className={styles.container}>
            <h2 className={styles.header}>Sync details</h2>
            {syncDetails.map((detail, i) => (<div key={i} className={styles.card}>
                    <dl className={commonStyles.summaryDetailsList(140, space[12])}>{getDetails(detail)}</dl>
                </div>))}
        </div>);
};
